import module from 'recursoshumanos/module.js'

const schema = {
  clase: 'number',
  registros: {
    id_movimiento: 'number',
    fecha_movimiento: 'date',
    salario_base: 'number',
    coincide_nombre: 'boolean',
    coincide_nss: 'boolean',
    coincide_salario: 'boolean',
    coincide_estatus: 'boolean',
  },
}

export class RecursosHumanosLotesIMSSService {
  constructor ($http) {
    this.$http = $http
  }

  post (data) {
    return this.$http.post('/api/recursos_humanos/lotes_imss', data, {
      schema,
    })
  }
}

module.service('RecursosHumanosLotesIMSS', RecursosHumanosLotesIMSSService)



// WEBPACK FOOTER //
// ./src/recursoshumanos/services/RecursosHumanos/LotesIMSS.js